import { render, staticRenderFns } from "./ListaTransactionCategory.vue?vue&type=template&id=979ce1a8"
import script from "./ListaTransactionCategory.vue?vue&type=script&lang=js"
export * from "./ListaTransactionCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports